// SharedAuthContext.js
// Single shared context that both Supabase and AWS providers use
import { createContext, useContext } from 'react';

// This is the ONE context object used by both providers
export const AuthContext = createContext({});

// This is the ONE useAuth hook - always import from here
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
